import { render, staticRenderFns } from "./LockerIssuePopup.vue?vue&type=template&id=513115fe&scoped=true&"
import script from "./LockerIssuePopup.vue?vue&type=script&lang=js&"
export * from "./LockerIssuePopup.vue?vue&type=script&lang=js&"
import style0 from "./LockerIssuePopup.vue?vue&type=style&index=0&id=513115fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513115fe",
  null
  
)

export default component.exports